import { render, staticRenderFns } from "./EnforcementMeasuresRegisterConsulted.vue?vue&type=template&id=f45b1b86&"
import script from "./EnforcementMeasuresRegisterConsulted.vue?vue&type=script&lang=ts&"
export * from "./EnforcementMeasuresRegisterConsulted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports